import cx from 'classnames';
import React, { useCallback, useEffect, useRef, useState } from 'react';
import { ActionMenu, } from '../../../../action-menu';
import { Icon, IconColor, IconID, IconSize } from '../../../../icon';
import { View } from '../../../../layout/flex-layout/flex-layout';
import { Popover } from '../../../../popover';
import { extendActionOnClick } from '../../object-table-action.util';
import { addListenerToHeaderCells } from '../column-header-util';
import styles from './icon-header.module.scss';
export const IconHeader = ({ column, }) => {
    const colDef = column.getColDef();
    const iconHeader = {
        ...colDef.headerComponentParams,
    };
    const [isActive, setIsActive] = useState(!!iconHeader.isActive);
    useEffect(() => {
        setIsActive(!!iconHeader.isActive);
    }, [iconHeader.isActive]);
    const getIconId = () => iconHeader.enableIconToggle &&
        !!iconHeader.isActive &&
        iconHeader.toggleIconId
        ? iconHeader.toggleIconId
        : iconHeader.icon.id;
    const defaultIconProps = {
        className: cx({
            [`${iconHeader.icon.className}`]: iconHeader.icon.className,
        }),
        id: getIconId(),
        color: iconHeader.icon.color || IconColor.TEXT_COLOR,
        size: iconHeader.icon.size || IconSize.MEDIUM,
    };
    const hoverIconProps = {
        id: IconID.CHEVRON_DOWN,
        color: IconColor.BLUE,
        size: IconSize.SMALL,
        className: styles.chevronDownIcon,
    };
    const [isPopoverOpen, setIsPopoverOpen] = useState(false);
    const popoverRef = useRef(null);
    const headerRef = useRef(null);
    const [iconContainerProps, setIconContainerProps] = useState(defaultIconProps);
    const [isHovering, setIsHovering] = useState(false);
    useEffect(() => {
        if (!isHovering && defaultIconProps.id !== iconContainerProps.id)
            setIconContainerProps(defaultIconProps);
    }, [defaultIconProps, iconContainerProps.id, isHovering]);
    const actions = extendActionOnClick(iconHeader.actions || [], setIsPopoverOpen, undefined, iconHeader.enableIconToggle
        ? {
            currentState: isActive,
            setState: setIsActive,
        }
        : undefined);
    const hasActionItems = actions.length > 0 && actions[0].items.length > 0;
    const onlySingleActionItem = actions.length === 1 && actions[0].items.length === 1
        ? actions[0].items[0]
        : null;
    const handleChange = useCallback((event) => {
        if (!hasActionItems) {
            return;
        }
        if (onlySingleActionItem &&
            onlySingleActionItem.onClick &&
            onlySingleActionItem.label) {
            onlySingleActionItem.onClick({
                id: onlySingleActionItem.id,
                label: onlySingleActionItem.label,
                event: event,
            });
            return;
        }
        setIsPopoverOpen(!isPopoverOpen);
    }, [hasActionItems, isPopoverOpen, onlySingleActionItem]);
    useEffect(() => {
        var _a;
        const parentElement = (_a = headerRef === null || headerRef === void 0 ? void 0 : headerRef.current) === null || _a === void 0 ? void 0 : _a.parentElement;
        addListenerToHeaderCells(parentElement, handleChange);
    }, [handleChange]);
    return (React.createElement("div", { className: cx(styles.iconHeaderContainer, {
            [styles.iconHeaderContainerHighlight]: hasActionItems && !iconHeader.disbaleHoverEffect,
        }), "data-tooltip-content": iconHeader.toolTip, "aria-label": iconHeader.toolTip, "data-testid": "icon-header-testid", ref: headerRef },
        React.createElement("div", { ref: popoverRef, className: styles.iconHeader, onMouseEnter: () => {
                if (hasActionItems && !iconHeader.disbaleHoverEffect) {
                    setIsHovering(true);
                    setIconContainerProps(hoverIconProps);
                }
            }, onMouseLeave: () => {
                if (hasActionItems) {
                    setIsHovering(false);
                    setIconContainerProps(defaultIconProps);
                }
            }, "data-testid": "icon-header-inner-container" },
            React.createElement(View, { className: cx(styles.iconHeaderView, {
                    [styles.defaultHoverState]: !hasActionItems,
                }), onClick: (event) => {
                    handleChange(event);
                } },
                React.createElement(Icon, { ...iconContainerProps }))),
        React.createElement(Popover, { align: "bottom-start", content: React.createElement(ActionMenu, { show: isPopoverOpen, menuItemGroups: actions, disableKeyboardNavigation: true }), targetRef: popoverRef, isVisible: isPopoverOpen, onClickOutside: () => setIsPopoverOpen(false) })));
};
//# sourceMappingURL=icon-header.js.map